module.exports = __webpack_public_path__ + "static/media/moon.09ccf7ca.svg";